<template>
  <v-card
    class="pa-0 align-center full-height"
    height="220px"
    :to="`/activity/${activity.slug}/`"
  >
    <div
      v-if="activity.source !== 'NONE'"
      :class="{
        halightblue:
          activity.source === 'APPROVED' || activity.source === 'COMMUNITY',
        halightorange: activity.source === 'FAVORITE',
        hafsoftgrey: activity.source === 'EXTERNAL',
      }"
      class="d-flex flex-row align-center text-center justify-center"
    >
      <span class="white--text font-italic text-caption">{{
        activity.source | getTextCard
      }}</span>
    </div>
    <v-row align="center" justify="center" class="pa-3 fill-available">
      <v-col cols="4" class="justify-center">
        <v-img :src="src" max-height="150px" />
      </v-col>
      <v-col class="py-0 card-text">
        <div class="font-weight-bold">{{ activity.headline }}</div>
        <p>{{ activity.short_description }}</p>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'LegacyActivityCard',
  filters: {
    getTextCard(source) {
      switch (source) {
        case 'APPROVED':
          return 'happyly approved'
        case 'FAVORITE':
          return 'local ambassador favorite'
        case 'EXTERNAL':
          return 'not visited by happyly'
        case 'COMMUNITY':
          return 'Community Generated Content'
        default:
          return ''
      }
    },
  },
  props: {
    activity: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    src() {
      return this.activity.header_thumbnail
        ? `${this.$config.staticUrl}${this.activity.header_thumbnail}`
        : require('@/assets/images/happyly_logo_placeholder.png')
    },
    address() {
      return 'Address here'
    },
  },
}
</script>
<style scoped>
.card-text {
  max-height: 170px;
  overflow-y: auto;
}
</style>
